import React, { useContext } from "react";
import WordCloud from "charts/WordCloud";
import { DataContext } from "App";

const ShowAttention: React.FC = () => {
  const appData = useContext(DataContext);

  return <WordCloud data={appData?.dimension?.play} />;
};

export default ShowAttention;
